<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
      <div class="dlblock-mb20 mr10">
        <span class="pr5">名称</span>
         <el-input v-model.trim="name" placeholder="请输入" style="width: 150px;"/>
      </div>
      
	  <div class="dlblock-mb20 mr10">
	    <span class="pr5">创建时间</span>
	    <el-date-picker
	        v-model="createTime"
	        style="width: 180px;"
	        type="datetime"
	  			class="reset-clear"
	  			:clearable="false"
	  			 unlink-panels
	        value-format="yyyy-MM-dd HH:mm:ss"
	        start-placeholder="开始时间"
	        />
	  </div> 
	  
	  
	  	<div class="dlblock-mb20 mr10">
	    <span class="pr5">结束日期</span>
	    <el-date-picker
	      v-model="updateTime"
	  		  style="width: 180px;"
	      type="datetime"
	      :clearable="false"
	      unlink-panels
	      end-placeholder="结束时间"
	      value-format="yyyy-MM-dd HH:mm:ss"
	       />
	  </div> 
	  
      <div class="dlblock-mb20 mr10">
        <el-button type="primary" @click="pages.page = 1; getHkFaceRecognitionRecordListFn()">
          搜索
        </el-button>
      </div>
    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="name" label="姓名"></el-table-column>
	  <el-table-column align="center" prop="type" label="类型"></el-table-column>
      <el-table-column align="center" prop="similarity" label="相似度"></el-table-column>
      <el-table-column align="center" prop="faceScore" label="人脸评分"></el-table-column>
      <el-table-column align="center" prop="certificates" label="证件信息"></el-table-column>
	  <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
	</el-table>  
	  
    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>
	
  </div>
</template>

<script>
  import {
    getHkFaceRecognitionRecordList
  } from '@/api'


  export default {
    name: 'UserList',	
    data () {
      return {
        date: [],
        status: '',
        city: [],
        cityList: [],
        agent: '',
        agentList: [],
        name: '',
        phoneNumber: '',
        tableData: [],
        tableLoading: false,
        pages: {
          page: 1,
          total: 0
        },
        // 详情
        detailId: '',
        detailModal: false,
        // 状态
        statusData: {
          modal: false,
          userId: '',
          type: '',
          typeName: '',
          date: [],
          content: ''
        },
		createTime:'',
		updateTime:''
      }
    },
    created () {
      this.getHkFaceRecognitionRecordListFn()
    },
    methods: {
      getHkFaceRecognitionRecordListFn () {
        this.tableLoading = true
        getHkFaceRecognitionRecordList({
          pageNum: this.pages.page,
          name: this.name,
          createTime: this.createTime,
          updateTime: this.updateTime
        }).then(res => {
          this.tableData = res.data.records
          this.pages.total = res.data.total
		  console.info(this.tableData,"响应的数据")
        }).finally(() => {
          this.tableLoading = false
        })
      },
      pageChange (val) {
        this.pages.page = val
        this.getHkFaceRecognitionRecordListFn()
      },
    }
  }
</script>

<style scoped>

</style>
